module.exports = __webpack_public_path__ + "static/media/remera.ff98d50f.webp";